// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
const ConfirmModalRecord = require('client-v2/common/containers/confirm-modal/record')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')
// Entry imports
const BannerSectionRecord = require('client-v2/logged-out-landing/containers/banner-section/record')
const HeroSectionRecord = require('client-v2/logged-out-landing/containers/hero-section/record')

class LandingRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Common containers
  confirmModal: null,
  // Entry state
  bannerSection: new BannerSectionRecord(),
  heroSection: new HeroSectionRecord()
}) {
  // No methods
}

LandingRootRecord.reviver = keyedReviver(LandingRootRecord, {
  // Common state
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Common containers
  confirmModal: ConfirmModalRecord.reviver,
  // Entry state
  bannerSection: BannerSectionRecord.reviver,
  heroSection: HeroSectionRecord.reviver
})

module.exports = LandingRootRecord
